export type AuthenticationAccessRight = (
  authenticationToken: AuthenticationToken,
) => boolean;

export class AuthenticationToken {
  public authenticationToken: string;
  public menuDisplayLevel: number;
  public merchantGroupUUID?: string;
  public merchantUUID?: string;
  public scopes: Set<string>;
  public isChat: boolean;
  public isBilling: boolean;
  public isSuspended: boolean;
  public isApproveDispatch: boolean;

  public constructor(obj: any) {
    this.isChat = obj.isChat ?? false;
    this.isBilling = obj.isBilling ?? false;
    this.isSuspended = obj.isSuspended ?? false;
    this.isApproveDispatch = obj.isApproveDispatch ?? false;
    this.authenticationToken = obj.authenticationToken;
    this.menuDisplayLevel = obj.menuDisplayLevel;
    this.scopes = obj.scopes ? new Set(obj.scopes) : new Set();
  }

  public canAccess(
    accessRight: AuthenticationAccessRight | AuthenticationAccessRight[],
  ): boolean {
    if (Array.isArray(accessRight)) {
      return accessRight.some(this.canAccess);
    } else {
      return accessRight(this);
    }
  }
}

export default AuthenticationToken;
